import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"

// Config
import PRConfig from "components/Stacker/config/ProductConfiguratorConfig"

// Components
import Icon from "components/Stacker/components/Icon/Icon"

// Actions
import { toggleToggle } from "components/Stacker/actions/ToggleActions"
import { resetPRC } from "components/Stacker/actions/ProductConfiguratorActions"

// Styles
import "./ProductConfigHeader.scss"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useRef } from "react"
import { useDispatch } from "react-redux"
import { useI18nContext } from "i18n/i18n-react"

function ProductConfigHeader({
  transitionFunc,
  currentStep,
  getHeaderHeight,
  configTypeValue,
}) {
  const node = useRef(0)
  const dispatch = useDispatch()
  const { LL } = useI18nContext()
  const enagraveableProductConfig = useSelector(
    (state) => state.toggle.enagraveableProductConfig
  )
  useEffect(() => {
    getHeaderHeight(getComputedStyle(node.current).height)
  }, [getHeaderHeight])

  const handleClose = () => {
    if (enagraveableProductConfig) {
      dispatch(toggleToggle("enagraveableProductConfig"), false)
    }
    setTimeout(() => {
      dispatch(resetPRC())
    }, 710)
  }

  return (
    <div className="ProductConfigHeader" ref={node}>
      <div className="container-fluid">
        <div className="product-config-header row d-flex align-items-center">
          <div className="col-3">
            <button
              className="product-config-header__back-btn hover-transition"
              value={PRConfig.PRC_SLIDEBACK_TRANSITION}
              onClick={currentStep === 1 ? handleClose : transitionFunc}
            >
              <div className="caret-left" />
              <span>{LL.productConfig.backText()}</span>
            </button>
          </div>
          <h6 className="col-6 text-center product-config-header__title">
            {configTypeValue === PRConfig.PENDANT_PRODUCTS.PRODUCT_TYPE
              ? LL.productConfig.engraveThisNecklaceText()
              : LL.productConfig.engraveThisRingText()}
          </h6>
          <div className="col-3 text-right product-config-header__close-btn d-flex align-items-center justify-content-end">
            <button onClick={handleClose} className="config-close-icon">
              <Icon iconName="icon-icon-close_small" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ProductConfigHeader.propTypes = {
  transitionFunc: PropTypes.func.isRequired,
  currentStep: PropTypes.number.isRequired,
  getHeaderHeight: PropTypes.func,
  configTypeValue: PropTypes.string,
}

export default ProductConfigHeader
